export default __webpack_public_path__ + "static/1863-eb3a34b8ca4d7e7c9d4de6170bfb52de.gif";